module.exports = __webpack_public_path__ + "img/0.971fe5ae.jpg";